import { object, string } from "yup";

export const businessDetailsSchema = object({
  entity_name: string().min(1, "Min. 1 character").required("Required"),
  entity_formation_type: string().required("Required"),
  ein_number: string().required("Required"),
  business_activity: string().required("Required"),
  naics_code: string().required("Required"),
  principal_place_of_business: object({
    uuid: string().required("Required"),
  }),
  business_phone: string().required("Required"),
  business_email: string()
    .email("Should be a valid email")
    .required("Required"),
});
